module.exports = __webpack_public_path__ + "static/media/commonEmpty.2e100033.png";